import { initializeApp } from "firebase/app";

export const FIREBASE_APP = initializeApp({
	apiKey: "AIzaSyDl9P4gpH-JfaYACUm1IeDWkSd2e7ro49w",
	authDomain: "trajectory-fit-production.firebaseapp.com",
	projectId: "trajectory-fit-production",
	storageBucket: "trajectory-fit-production.appspot.com",
	messagingSenderId: "750310095750",
	appId: "1:750310095750:web:20f625ed61df2fa7f9ca07",
});
